export const FRAME_CONTAINER_PADDING_TOP = 16;
export const FRAME_SIZE = 10;
export const RULER_HEIGHT = 12;
export const FRAME_MIN_HEIGHT = 20;
export const FRAME_EXPANDED_MIN_HEIGHT = 400;
export const FRAME_EXTRA_SPACE = 10;
export const MAX_DEPTH_FOR_COLLAPSED = 8;
export const FPS = 60;
export const MARKER_LINE_WIDTH = 2;
export const FRAME_MID_POSITION = FRAME_SIZE / 2 - MARKER_LINE_WIDTH / 2;
/**
 * KeyFrame icon is square rotated 45deg to look like diamond
 * Diagonal of the square = width of frame
 *  */
export const KEYFRAME_SIZE = Math.sqrt(FRAME_SIZE ** 2 / 2).toFixed(2);
export const TIMELINE_HEIGHT = 20;
export const TIMELINE_CONTAINER_GUTTER = 20;
export const FRAME_MAX_HEIGHT = MAX_DEPTH_FOR_COLLAPSED * TIMELINE_HEIGHT + FRAME_EXTRA_SPACE;
export enum FrameView {
  TIME,
  FRAME,
}
export const FRAME_CONTROL_MODE = ({
  NORMAL: 'normal',
  COMPACT: 'compact'
} as const);
export const KEY_FRAME_TYPE = ({
  MANUAL: 'MANUAL',
  AUTOMATED: 'AUTOMATED'
} as const);
export const BBOX_TRACKING_WARNING_MESSAGE = 'No bounding box tracking data found for frame';
export const ACTION_TYPE = ({
  TRACK: 'track',
  TRACK_30: 'track_30',
  INTERPOLATION: 'interpolation'
} as const);
export const SEGMENTED_CONTROL_HEIGHT = 50;
export const SEQUENCE_OVERRIDE_MODAL = ({
  track: {
    TITLE: 'Override Existing Annotations?',
    CONFIRM_BUTTON: 'Override & Track'
  },
  interpolate: {
    TITLE: 'Override Existing Annotations?',
    CONFIRM_BUTTON: 'Override & Interpolate'
  },
  CANCEL_BUTTON: 'Cancel',
  ICON: {
    SIZE: 24
  }
} as const);